export const getRandomElement = <T>(arr: T[]) =>
  arr[Math.floor(Math.random() * arr.length)]
